/**
 * @description
 * Objeto Cas
 */

export class Cas {
    public id:number = null;
    public code:string = "";
    public cnIssuer:string;
    public sn:string;
    public cn:string;
    public email:string;
    public cnregexp:string;
    public snregexp:string;
    public emailregexp:string;
  
    constructor() {}
}